import { launchError, launchSuccess } from "components/notifications";
import { useContext, useState } from "react";
import { useTranslation } from 'react-i18next';
import './userGoliathsPlus.css'
import { formatDate } from "utils/date";
import { cancelGoliathsPlusSubscription } from "services/subscriptionsServices";
import { offerGoliathsPlusFreeSubscription } from "services/userServices";
import AuthContext from "contexte/AuthContext";

const FREE_MONTHS_OPTIONS = [1, 3, 6, 12];

const UserGoliathsPlus = ({ userData, setUserData, user, id }) => {

  const { t } = useTranslation();

  const { verifyUser } = useContext(AuthContext);
  const role = verifyUser()?.role;


  const [monthsToOffer, setMonthsToOffer] = useState(3);

  const formatGoliathsPlusPlan = (subscription) => {
    switch (subscription.subscription_plan) {
      case 'yearly':
        return 'Annuel'
      case '5_years':
        return '5 ans'
      case 'trial':
        return `Essai ${subscription.current_free_months} mois offert`
      default:
        return 'Erreur'
    }
  }

  const formatSubscriptionDuration = (goliaths_plus) => {
    const { subscription_plan, interval_increment } = goliaths_plus
    switch (subscription_plan) {
      case 'yearly':
        return `${Math.max(1, interval_increment)} année(s)`
      case '5_years':
        return `${Math.max(1, interval_increment) * 5} année(s)`
      case 'trial':
        return '3 mois'
      default:
        return 'Erreur'
    }
  }

  const cancelSubscription = async () => {
    try {
      await cancelGoliathsPlusSubscription(user, id);
      setUserData(prev => ({ ...prev, goliaths_plus: null }))
      launchSuccess(t('notifications.users.userById.goliaths_plus_unsubscribe.success'));
    } catch (error) {
      console.log('=======Error', error)
      launchError(t('notifications.users.userById.goliaths_plus_unsubscribe.error'));
    }
  }

  const freeSubscription = async () => {
    try {
      const { goliaths_plus, extended } = await offerGoliathsPlusFreeSubscription(user, id, monthsToOffer);
      setUserData(prev => ({ ...prev, goliaths_plus }));
      launchSuccess(t(extended
        ? 'notifications.users.userById.goliaths_plus_free_subscription.extended_success'
        : 'notifications.users.userById.goliaths_plus_free_subscription.success', { months: monthsToOffer }))
    } catch (error) {
      launchError(t('notifications.users.userById.goliaths_plus_free_subscription.error'))
    }
  }


  return <div className='user_goliaths_plus_main_div'>
    <p className='user_goliaths_plus_title'>Goliaths Plus :</p>
    {/* <button className="user_goliaths_plus_cancel_subscription_button">Rembourser l'abonnement</button> */}
    {/* </div> */}
    <div className='user_row_space_between_box'>
      <div className='user_goliaths_plus_column'>
        <p className='user_goliaths_plus_p user_goliaths_plus_item_desc'><span className='user_goliaths_plus_label'>Abonnement : </span>{userData.goliaths_plus?.is_subscribed ? 'Oui' : 'Non'}</p>
        {userData.goliaths_plus?.is_subscribed &&
          <>
            <p className='user_goliaths_plus_p user_goliaths_plus_item_desc'><span className='user_goliaths_plus_label'>Renouvellement automatique : </span>{userData.goliaths_plus?.auto_renewal ? 'Oui' : 'Non'}</p>
            <p className='user_goliaths_plus_p user_goliaths_plus_item_desc'><span className='user_goliaths_plus_label'>Total follows : </span>{userData.goliaths_plus?.total_follows}</p>
          </>
        }
      </div>
      {userData.goliaths_plus?.is_subscribed &&
        <div className='user_goliaths_plus_column'>
          <p className='user_goliaths_plus_p user_goliaths_plus_item_desc'><span className='user_goliaths_plus_label'>Plan :</span>{formatGoliathsPlusPlan(userData.goliaths_plus)}</p>
          <p className='user_goliaths_plus_p user_goliaths_plus_item_desc'><span className='user_goliaths_plus_label'>Durée de l'abonnement : </span> {formatSubscriptionDuration(userData.goliaths_plus)}</p>
          {userData.goliaths_plus?.total_free_months && <p className='user_goliaths_plus_p user_goliaths_plus_item_desc'><span className='user_goliaths_plus_label'>Total de mois offerts : </span> {userData.goliaths_plus?.total_free_months}</p>}
        </div>
      }
      {userData.goliaths_plus?.is_subscribed &&
        <div className='user_goliaths_plus_column'>
          <p className='user_goliaths_plus_p user_goliaths_plus_item_desc'><span className='user_goliaths_plus_label'>Date de début d'abonnement : </span>{formatDate({ date: userData.goliaths_plus?.subscription_start_date })}</p>
          <p className='user_goliaths_plus_p user_goliaths_plus_item_desc'><span className='user_goliaths_plus_label'>Date du prochain paiement : </span>{formatDate({ date: userData.goliaths_plus?.next_payment_date })}</p>
        </div>
      }
    </div>

    {[1, 2, 4].includes(role) && < div className="user_goliaths_plus_actions_box">
    <div className="user_goliaths_plus_offer_subscription_group">
      <span className="user_goliaths_plus_offer_subscription_label">Offrir des mois d'abonnement</span>
      <div className="user_goliaths_plus_offer_subscription_control">
        <select
          id='goliaths_plus_months_select'
          className='user_goliaths_plus_months_select'
          value={monthsToOffer}
          onChange={(e) => setMonthsToOffer(Number(e.target.value))}
        >
          {FREE_MONTHS_OPTIONS.map((months) => (
            <option key={months} value={months}>{months} mois</option>
          ))}
        </select>
        <button className="user_goliaths_plus_offer_subscription_button" onClick={freeSubscription}>Offrir</button>
      </div>
    </div>
    <button className="user_goliaths_plus_cancel_subscription_button" disabled={!userData.goliaths_plus?.is_subscribed || userData.goliaths_plus?.total_follows > 0} onClick={cancelSubscription}>Rembourser l'abonnement</button>
  </div>
}
  </div >
}

export default UserGoliathsPlus